import {CustomError} from "../../shared/errors/CustomErrors";
import {Option} from "../../shared/utilities/OptionT";
import {APIDao, Requester} from "../APIRequester";
import {SCHEDULED_SHIPMENT_API_PREFIX} from "../../common/constants";

/**
 * UserRepository.
 *
 * Responsible for fetching data from backend
 * by callind APIDao and handling various data
 * coming from API
 *
 * Data is passed to UserService in a form of
 * an @type Option<T> type, where @param{Some: T} is either
 * a valid data, expected from the server,
 * or, in case of error, a default safe value,
 * for an object of array (kinda like default
 * values for types in Go),and @param{None: CustomError}
 * is either an error or undefined
 */
export class ScheduledShipmentRepository<T> {
    private dao: Requester

    constructor(dao: Requester) {
        this.dao = dao
    }

    public async createOrEdit(data: any): Promise<Option<any>> {
        return await this.dao.postRequest<any>(`${SCHEDULED_SHIPMENT_API_PREFIX}/create-or-edit`, {data}).then(res => {
            const result: Option<any> = {
                Some: res.data,
            }
            return result
        }).catch((err: CustomError) => {
            const result: Option<any> = {
                Some: {} as -1,
                None: err
            }
            return result
        })
    }
    public async remove(params: {}): Promise<Option<any>> {
        return await this.dao.postRequest<any>(`${SCHEDULED_SHIPMENT_API_PREFIX}/remove`, {params: {...params}}).then(res => {
            const result: Option<any> = {
                Some: res.data,
            }
            return result
        }).catch((err: CustomError) => {
            const result: Option<any> = {
                Some: {} as -1,
                None: err
            }
            return result
        })
    }

    public async force(params: {}): Promise<Option<any>> {
        return await this.dao.postRequest<any>(`${SCHEDULED_SHIPMENT_API_PREFIX}/force`, {params: {...params}}).then(res => {
            const result: Option<any> = {
                Some: res.data,
            }
            return result
        }).catch((err: CustomError) => {
            const result: Option<any> = {
                Some: {} as -1,
                None: err
            }
            return result
        })
    }
    public async all(data: any): Promise<Option<any>> {
        return await this.dao.postRequest<any>(`${SCHEDULED_SHIPMENT_API_PREFIX}/all`, data).then(res => {
            const result: Option<any> = {
                Some: res.data,
            }
            return result
        }).catch((err: CustomError) => {
            const result: Option<any> = {
                //@ts-ignore
                Some: {} as any,
                None: err
            }
            return result
        })
    }
}

export const ScheduledShipmentRepositoryInstance = new ScheduledShipmentRepository(APIDao)
